<template>
  <div id="page">
    <section
        class="category_top_banner s_cat_in_top_banner cover"
        v-lazy:background-image="pageData.acf.titlebar.bg && $mq !== 'mobile' ? pageData.acf.titlebar.bg : (pageData.acf.titlebar.bg_mobile ? pageData.acf.titlebar.bg_mobile : pageData.acf.titlebar.bg)"
    >
      <div class="container" :class="{ 'white-text': pageData.acf.titlebar.white_text }">
        <h1 class="title">{{ pageData.acf.titlebar.title ? pageData.acf.titlebar.title : pageData.title }}</h1>
        <div class="text">{{ pageData.acf.titlebar.subtitle ? pageData.acf.titlebar.subtitle : '' }}</div>
      </div>
      <div class="bn_corner"></div>
    </section>
    <div class="container">
      <div class="main_white main page col-lg-12">
        <div class="col-lg-7">
          <div class="page-content" v-html="pageData.post_content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				title: "",
				content: "",
				page: "",
			};
		},
		computed: {
			pageData() {
				if (typeof wpData.pageData != "object") {
					return JSON.parse(wpData.pageData);
				}
				return wpData.pageData;
			},
		},
		beforeCreate() {},
		created() {
			this.$modal.hide("login-modal");
      console.log('this.pageData', this.pageData);
		},
	};
</script>
<style lang="sass" scoped>
#page
  .category_top_banner
    padding-top: 0
    .container
      height: calc(100% - 30px)
      display: flex
      flex-direction: column
      justify-content: center
    h1
      margin: 0
      font-size: 35px
      font-weight: bold
      font-family: simpler, arial, sans-serif

    .text
      height: auto
      color: #1e824c
      font-family: 'raanancondensed', arial, sans-serif
      font-size: 50px
      line-height: normal

  .main
    border-radius: 0
    background: #fff url(../assets/img/cashback-bg.jpg) repeat-y top left/32% auto

  h1
    font-size: 28px

  h2
    color: #1e824c
    font-family: 'raanancondensed', arial, sans-serif
    font-size: 48px

  .subtitle
    font-size: 36px
    color: #000
    font-family: 'raanancondensed', arial, sans-serif
    line-height: 28px

@media (max-width: 480px)
  #page
    .main
      background: none
      .col-lg-7
        padding: 0
      h2
        font-size: 31px
</style>